import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AuditLogDialog } from '../common/AuditLogDialog';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { ScrollText, ShieldCheck } from 'lucide-react';

/**
 * Sicurezza & Registro Attività (anti-frode).
 * L'accesso al Registro (Admin + Manager) è protetto dal PIN del PROFILO
 * (lo stesso usato per accedere). Il PIN si gestisce dalla pagina Utenti.
 */
export const SecuritySettings = () => {
  const { t } = useTranslation();
  const [auditOpen, setAuditOpen] = useState(false);

  return (
    <>
      {/* Accesso al Registro Attività (Admin + Manager) */}
      <Card className="p-5 mb-4" data-testid="security-audit-card">
        <div className="font-semibold mb-1 flex items-center gap-2">
          <ScrollText className="h-4 w-4 text-muted-foreground" /> {t('security.auditTitle')}
        </div>
        <p className="text-sm text-muted-foreground mb-4">
          {t('security.auditDesc')}
        </p>
        <Button className="rounded-xl" onClick={() => setAuditOpen(true)} data-testid="open-audit-log-button">
          <ScrollText className="h-4 w-4 mr-2" /> {t('security.openAudit')}
        </Button>
      </Card>

      {/* Nota informativa: il PIN del Registro è quello del profilo. */}
      <Card className="p-5 mb-4" data-testid="security-pin-info-card">
        <div className="font-semibold mb-1 flex items-center gap-2">
          <ShieldCheck className="h-4 w-4 text-muted-foreground" /> {t('security.profilePinTitle')}
        </div>
        <p className="text-sm text-muted-foreground">
          {t('security.profilePinDesc')}
        </p>
      </Card>

      <AuditLogDialog open={auditOpen} onOpenChange={setAuditOpen} />
    </>
  );
};

export default SecuritySettings;
